// extracted by mini-css-extract-plugin
export default {"page":"Form_page__VOr9b","modal":"Form_modal__3_By1","formContainer":"Form_formContainer__5WGbR","pages":"Form_pages__1xdT-"};